import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    TextField,
    Box
} from '@mui/material';
import { authService } from '../../services/auth.service';
import { toastService } from '../../services/toast.service';
import { ModalIndices } from '../../common/i-doc/i-doc.registry.ts';

interface EmailVerificationModalProps {
    open: boolean;
    onClose: () => void;
    userEmail: string; // Add userEmail prop
    onVerificationSuccess: () => void; // Callback on successful verification
}

export const EmailVerificationModal: React.FC<EmailVerificationModalProps> = ({ open, onClose, userEmail, onVerificationSuccess }) => {
    const [verificationCode, setVerificationCode] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const handleResendCode = async () => {
        setLoading(true);
        try {
            await authService.resendEmailVerificationCode(userEmail);
          toastService.success('Код підтвердження надіслано повторно!');
        } catch (error: any) {
          toastService.error(error.response?.data?.message || 'Помилка при повторній відправці коду.');
        } finally {
            setLoading(false);
        }
    };

    const handleVerify = async () => {
        setLoading(true);
        try {
            await authService.verifyEmail({ email: userEmail, code: verificationCode });
          toastService.success('Email успішно підтверджено!');
            onVerificationSuccess(); // Call success callback
            setVerificationCode(''); // Clear input
        } catch (error: any) {
          toastService.error(error.response?.data?.message || 'Невірний або прострочений код підтвердження.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" data-i-doc={ModalIndices.EMAIL_VERIFICATION}>
            <DialogTitle>Підтвердження Email</DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Будь ласка, введіть код підтвердження, який ми надіслали на вашу електронну пошту ({userEmail}).
                </Typography>
                <TextField
                    fullWidth
                    label="Код підтвердження"
                    value={verificationCode}
                    onChange={(e) => setVerificationCode(e.target.value)}
                    margin="normal"
                    disabled={loading}
                />
                <Box sx={{ mt: 2 }}>
                    <Button variant="text" onClick={handleResendCode} disabled={loading}>Надіслати код повторно</Button>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Скасувати</Button>
                <Button variant="contained" onClick={handleVerify} disabled={!verificationCode.trim() || loading}>Підтвердити</Button>
            </DialogActions>
        </Dialog>
    );
};
